var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item',{attrs:{"to":_vm.path,"active":_vm.$route.path.startsWith(_vm.path)}},[_vm._v(_vm._s(_vm.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }